import { getImageUrl } from "Common/utils/ImageDomain";

interface ImageDataProps {
  imageLink: string;
  setImageData: React.Dispatch<React.SetStateAction<any>>;
  setImageLink: React.Dispatch<React.SetStateAction<any>>;
  isEditable?: boolean;
}

const ImageData: React.FC<ImageDataProps> = ({
  imageLink,
  setImageData,
  setImageLink,
  isEditable = true,
}) => {
  const imageUrl = getImageUrl(imageLink);
  return (
    <div className="relative w-40 h-40">
      {imageUrl ? (
        <img
          data-dz-thumbnail
          className="rounded border-[gray] border"
          style={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
          src={imageUrl}
          alt="Uploaded image"
        />
      ) : (
        <p>No image available</p>
      )}
      <span
        style={{
          position: "absolute",
          top: "0px",
          right: "6px",
          fontSize: "22px",
          cursor: "pointer",
        }}
        onClick={isEditable ? () => {
          setImageData(null);
          setImageLink(null);
        }
      :null}
      >
        ×
      </span>
    </div>
  );
};

export default ImageData;
